import { render } from "./QwSteps.vue?vue&type=template&id=5fa71496"
import script from "./QwSteps.vue?vue&type=script&lang=js"
export * from "./QwSteps.vue?vue&type=script&lang=js"

import "./QwSteps.vue?vue&type=style&index=0&id=5fa71496&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__